$(document).one('turbo:load', function () {
	if (!$('.registrations.new').length) return;
	if (window.registrationNewPageInitialized) return;
	window.registrationNewPageInitialized = true;
	$('input#user_email').keyup(function () {
		$('data#email_valid').remove();
		$('data#email_taken').remove();
		$('data#email_invalid').remove();

		if ($('data#start_email_search').length === 0) {
			$('<data id="start_email_search" email=""></data>').appendTo('body');
			setInterval(startSearch, 2000);
		}
	});

	// (Start) So that we can search once the user stops typing.
	function startSearch() {
		var original_value = $('data#start_email_search').attr('email');
		var new_value = $('input#user_email').val();
		var validated = $('data#email_valid').length > 0;
		var email_taken = $('data#email_taken').length > 0;
		var invalid = $('data#email_invalid').length > 0;

		if (original_value == new_value && !validated && !email_taken && !invalid) {
			checkEmail('input#user_email', true);
		} else if (original_value != new_value) {
			$('#email_inline_validation').hide();

			if (validated || email_taken || invalid) {
				checkEmail('input#user_email', true);
			}
		}

		$('data#start_email_search').attr('email', new_value);
	}
	// (End)

	function checkEmail(field, async) {
		var email = $(field).val();
		var validate = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

		if (validate.test(email) === true) {
			cursorStyle('wait');

			$.ajax({
				method: 'POST',
				async: async,
				url: "/ajax/check_user_email",
				data: { email: email },
				success: function (response) {
					$('data#email_valid').remove();
					$('data#email_taken').remove();
					$('data#email_invalid').remove();
					$('#email_inline_validation').removeClass('text-red');

					if (response.exists) {
						$('#email_inline_validation').addClass('text-red');
						inlineValidationNotice('#email_inline_validation', 'Oops, this email already exists. Try logging in instead.', false);
						$('<data id="email_taken"></data>').appendTo('body');
					} else if (response.fake) {
						$('#email_inline_validation').addClass('text-red');
						inlineValidationNotice('#email_inline_validation', 'Your email looks fake. We do not accept your email provider.', false);
						$('<data id="email_taken"></data>').appendTo('body');
					} else {
						$('#email_inline_validation').addClass('text-green');
						inlineValidationNotice('#email_inline_validation', 'This email is valid.', true);
						$('<data id="email_valid"></data>').appendTo('body');
					}

					cursorStyle('default');
				}
			});
		} else {
			inlineValidationNotice('#email_inline_validation', 'This does not look like a valid email address.', false);
			$('<data id="email_invalid"></data>').appendTo('body');
		}

		$('data#start_email_search').attr('email', email);
	}

	$('#registrations_submit').click(function (e) {
		var fields = getFieldValues('.must_fill');
		var email = $('#user_email').val();
		var password = $('#user_password').val();
		var confirm = $('#user_password_confirmation').val();
		var validated = $('data#email_valid').length > 0;

		if (!validated) {
			checkEmail('input#user_email', false);
		}

		if (fields.includes('')) {
			submitAlert(e, 'You must fill up all fields');
		} else if ($('data#email_valid').length === 0) {
			submitAlert(e, 'Oops, your email seems to be invalid. Try again?');
		} else if (password.length < 8) {
			submitAlert(e, 'Your password has to be a minimum 8 characters.');
		} else if (password !== confirm) {
			submitAlert(e, 'Oops! Your password does not match.');
		} else if ($('#user_firstname').val() === $('#user_lastname').val()) {
			submitAlert(e, 'Your first name and last name cannot be the same');
		} else {
			$('#registrations_submit').hide();
			$('#registrations_submit_message').fadeIn('fast');
		}
	});
});